import { render, staticRenderFns } from "./DataIndukKelas.vue?vue&type=template&id=477c1ae2"
import script from "./DataIndukKelas.vue?vue&type=script&lang=js"
export * from "./DataIndukKelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports